import React from "react";
import { useSelector } from "react-redux";
import { selectState } from "../../store/slices/themeSlice";
import useCustomStyles from "../../hooks/useCustomStyles";
import { customProgressBarStyles } from "../../assets/styles/customProgressBarStyles";
 
interface CustomProgressBarProps {
  limit: number;
  currentCount: number;
  variant?: "primary" | "golden";
  // Unused - the bar now fills 100% of its parent and sizes its segments
  // by percentage. Kept optional so existing callers don't need to change.
  width?: number;
}

const CustomProgressBar: React.FC<CustomProgressBarProps> = ({
  limit,
  currentCount,
  variant = "primary",
}) => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(customProgressBarStyles, theme);

  const calculateFillPercentage = () => {
    if (limit === 0) return 0;
    return Math.min(100, (currentCount / limit) * 100);
  };

  const fillPercentage = calculateFillPercentage();

  const fillGradient =
    variant === "primary"
      ? `linear-gradient(to right, ${theme.colorSchema.colors.progressBarDashboard[0]}, ${theme.colorSchema.colors.progressBarDashboard[1]})`
      : "linear-gradient(to right, #FFE998, #57370D)";

  return (
    <div className={classes.container} style={{ width: "100%" }}>
      <div
        className={classes.filled}
        style={{
          width: `${fillPercentage}%`,
          background: fillGradient,
        }}
      />
      <div
        className={classes.unfilled}
        style={{
          width: `${100 - fillPercentage}%`,
        }}
      />
    </div>
  );
};
 
export default CustomProgressBar